import { Api } from '../api/root-api';

import {
  CreateSchedulerRequest,
  CreateSchedulerResponse,
  SchedulersRequest,
  Scheduler,
  activeSchedulersRequest,
  activeSchedulersResponse,
  CreateReportsSchedulerRequest,
  ReportsSchedulerResponse,
  GetReportsSchedulerRequest,
  DeleteReportsSchedulerRequest,
  DeliveryLogsResponse,
  DeliveryLogsRequest,
  TriggerReportSchedulerRequest,
} from './model';

export const schedulersApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    createScheduler: builder.mutation<
      CreateSchedulerResponse,
      CreateSchedulerRequest
    >({
      query(args) {
        return {
          url: `hub/reports/api/v1/scheduler/${args?.workspaceId}`,
          method: 'POST',
          body: args,
        };
      },
    }),

    getSchedulers: builder.query<Scheduler[], SchedulersRequest>({
      query(arg) {
        const { reportId, ...otherParams } = arg;
        return {
          url: `hub/reports/api/v1/scheduler/details/${reportId}`,
          params: otherParams,
          method: 'GET',
        };
      },
    }),

    activeSchedulers: builder.query<
      activeSchedulersResponse,
      activeSchedulersRequest
    >({
      query(arg) {
        const { schedulerId, workspaceId, ...otherParams } = arg;
        return {
          url: `hub/reports/api/v1/scheduler/generate/${schedulerId}/${workspaceId}`,
          method: 'GET',
          params: otherParams,
        };
      },
    }),

    // --- Reports Scheduler (new API) ---
    createReportsScheduler: builder.mutation<
      ReportsSchedulerResponse,
      CreateReportsSchedulerRequest
    >({
      query(args) {
        const { sellerWorkspaceId, ...body } = args;
        return {
          url: `hub/reports/api/v1/reports-scheduler`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body: { sellerWorkspaceId, ...body },
        };
      },
    }),

    getReportsSchedulers: builder.query<
      { schedules: ReportsSchedulerResponse[]; sample_order: Object },
      GetReportsSchedulerRequest
    >({
      query(arg) {
        return {
          url: `hub/reports/api/v1/reports-scheduler`,
          method: 'GET',
          params: arg,
        };
      },
    }),

    deleteReportsScheduler: builder.mutation<
      ReportsSchedulerResponse,
      DeleteReportsSchedulerRequest
    >({
      query(arg) {
        return {
          url: `hub/reports/api/v1/reports-scheduler`,
          method: 'DELETE',
          params: arg,
        };
      },
    }),

    getDeliveryLogs: builder.query<DeliveryLogsResponse, DeliveryLogsRequest>({
      query(arg) {
        return {
          url: `hub/reports/api/v1/reports-scheduler/delivery-logs`,
          method: 'GET',
          params: arg,
        };
      },
    }),
    triggerReportScheduler: builder.mutation<
      any,
      TriggerReportSchedulerRequest
    >({
      query(arg) {
        const { sellerWorkspaceId } = arg;
        return {
          url: `/hub/reports/api/v1/reports-scheduler/trigger-report`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body: arg.body,
        };
      },
    }),
  }),
});

export const {
  useCreateSchedulerMutation,
  useLazyGetSchedulersQuery,
  useLazyActiveSchedulersQuery,
  useCreateReportsSchedulerMutation,
  useLazyGetReportsSchedulersQuery,
  useDeleteReportsSchedulerMutation,
  useLazyGetDeliveryLogsQuery,
  useTriggerReportSchedulerMutation,
} = schedulersApi;
